module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    staticClass: "popup-message-box",
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "message-pop-content"
  }, [_c('div', [_c('div', {
    staticClass: "confirm-box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "message-box-title flex-row flex-align-center"
  }, [_c('div', {
    staticClass: "flex-1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("title")], 2), _vm._v(" "), _c('span', {
    staticClass: "right-fork"
  })])]), _vm._v(" "), _c('scroll', {
    staticClass: "message-scroll"
  }, [_vm._t("list")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b648308","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmListBox.vue
// module id = 838
// module chunks = 0